import { useMemo } from "react";
import { LocalDateString } from "@lib/store/src/data/timeslots/apiTypes";
import { H4 } from "@quarks";
import { cn } from "@utils";
import { DonutChart } from "@molecules";
import { useConnections } from "src/components/pages/Connections";
import { getAcceptedGroupMembersWithWorkdays, useAppSelector } from "@lib/store";
import { useParams } from "react-router-dom";

export const AttendanceItem = ({ dayKey, className }: { dayKey: LocalDateString; className?: string }) => {
  const { compactView } = useConnections();
  const { groupId } = useParams();
  const groupMembersWithWorkdays = useAppSelector(state => getAcceptedGroupMembersWithWorkdays(state, groupId || ""));

  const maxOfficeDayCount = useMemo(() => groupMembersWithWorkdays.length, [groupMembersWithWorkdays]);
  const officeDayCountOnDay = useMemo(() => {
    return groupMembersWithWorkdays.reduce((count, member) => {
      const hasOfficeDay = member.workdays.some(wd => wd.localStart.startsWith(dayKey) && wd.status === "OfficeDay");
      return hasOfficeDay ? count + 1 : count;
    }, 0);
  }, [groupMembersWithWorkdays, dayKey]);

  return (
    <DonutChart
      numberOfMembers={maxOfficeDayCount}
      numberOfOfficeDaysOnDay={officeDayCountOnDay}
      className={className}>
      <div
        className={cn("size-5 flex items-center justify-center", {
          "size-8": !compactView,
        })}>
        {!compactView && <H4 className="p-0 leading-[1px]">{officeDayCountOnDay}</H4>}
      </div>
    </DonutChart>
  );
};
